var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XMLID_468_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.065,
    height: 16.065,
    viewBox: "0 0 16.065 16.065",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_469_",
    d: "M88.558,84.725c-.031-.015-1.2-.592-1.411-.667a.81.81,0,0,0-.273-.06.464.464,0,0,0-.394.234c-.117.174-.471.588-.581.712-.014.016-.034.036-.045.036s-.192-.075-.247-.1A6.163,6.163,0,0,1,83.267,82.8a.129.129,0,0,1-.02-.046.378.378,0,0,1,.069-.081c.064-.063.133-.146.2-.227.032-.038.063-.076.095-.112a1.262,1.262,0,0,0,.19-.3l.026-.053a.546.546,0,0,0-.016-.514c-.028-.055-.522-1.249-.575-1.374-.126-.3-.293-.443-.526-.443l-.09,0a2.807,2.807,0,0,0-.974.25,2.039,2.039,0,0,0-.756,1.734,3.738,3.738,0,0,0,.81,2.058l.033.048a7.63,7.63,0,0,0,3.273,2.841,5.322,5.322,0,0,0,1.977.505h0a3.086,3.086,0,0,0,.322-.019l.057-.005a2.078,2.078,0,0,0,1.449-1.025,1.621,1.621,0,0,0,.092-1.067A.739.739,0,0,0,88.558,84.725Z",
    transform: "translate(-76.671 -75.494)",
    fill: "#37b37f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_470_",
    d: "M8.175,0A7.87,7.87,0,0,0,.285,7.831a7.774,7.774,0,0,0,1.082,3.96l-1.355,4a.209.209,0,0,0,.261.266l4.169-1.325a7.9,7.9,0,0,0,11.625-6.9A7.87,7.87,0,0,0,8.175,0Zm0,14.031a6.251,6.251,0,0,1-3.439-1.025.209.209,0,0,0-.178-.024l-2.088.664.674-1.989a.209.209,0,0,0-.029-.19,6.115,6.115,0,0,1-1.19-3.634,6.25,6.25,0,1,1,6.25,6.2Z",
    transform: "translate(0)",
    fill: "#37b37f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.eaa7507b122d48b6691c3b17d10ad2b7.svg";
export { ForwardRef as ReactComponent };